import { Element } from '@svgdotjs/svg.js';

import { formatColor } from './formatColor';

const getStrokeFromElementStyle = (element: Element): string | null => {
    const style = element.attr('style') as string;

    if (!style) {
        return null;
    }

    const strokeColor = style.match('/(stroke:[^;]+;?)/')?.shift();

    if (!strokeColor || strokeColor === 'none') {
        return null;
    }

    return formatColor(strokeColor);
};

const getStrokeFromElementAttribute = (element: Element): string | null => {
    const attributeStrokeColor = element.attr('stroke');

    if (attributeStrokeColor === 'none') {
        return null;
    }

    return formatColor(attributeStrokeColor);
};

export const getStrokeFromElement = (element: Element): string | null => {
    const styleStrokeColor = getStrokeFromElementStyle(element);

    if (styleStrokeColor) {
        return styleStrokeColor;
    }

    return getStrokeFromElementAttribute(element);
};
